import { render, staticRenderFns } from "./decision-support.vue?vue&type=template&id=615419b0"
import script from "./decision-support.vue?vue&type=script&lang=js"
export * from "./decision-support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports